export default "__VITE_ASSET__B1zA1EwV__"